(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const desktopHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function initGallery(gallery) {
    if (gallery.dataset.ynGalleryReady === 'true') return;

    gallery.addEventListener(
      'click',
      (event) => {
        if (!desktopQuery.matches) return;

        const imageOpener = event.target.closest('.product__modal-opener--image');
        if (!imageOpener || !gallery.contains(imageOpener)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const controls = gallery.querySelector('[data-yn-gallery-controls]');
    const previous = controls?.querySelector('[data-yn-gallery-previous]');
    const next = controls?.querySelector('[data-yn-gallery-next]');
    const mediaLabel = gallery.querySelector('[data-yn-gallery-label]');
    const mediaCount = gallery.querySelector('[data-yn-gallery-count]');
    const items = Array.from(viewer?.querySelectorAll('.product__media-list > .product__media-item[data-media-id]') || []);

    // The quick-view ("Choose options") modal reuses this same gallery markup, but
    // Dawn's quick-add-modal CSS force-hides every media item except the first
    // (`quick-add-modal .product__media-item:not(:first-child) { display: none !important; }`)
    // — that modal is only ever meant to show one static image, by design. Our
    // prev/next overlay isn't covered by that rule, so without this guard it stays
    // clickable there; clicking it moves the active slide onto a permanently
    // hidden item, leaving a blank white gap with no way back. CSS also hides the
    // controls there, but skip wiring them up at all as a second, independent
    // safeguard in case that stylesheet doesn't load.
    const insideQuickAddModal = !!gallery.closest('quick-add-modal');

    if (!viewer || !controls || !previous || !next || items.length < 2 || insideQuickAddModal) {
      controls?.setAttribute('hidden', '');
      return;
    }

    gallery.dataset.ynGalleryReady = 'true';

    const update = () => {
      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      previous.disabled = activeIndex <= 0;
      next.disabled = activeIndex < 0 || activeIndex >= items.length - 1;

      if (activeIndex >= 0) {
        if (mediaLabel) {
          mediaLabel.textContent = items[activeIndex].dataset.mediaLabel || '';
        }
        if (mediaCount) {
          mediaCount.textContent = `${activeIndex + 1} / ${items.length}`;
        }
      }
    };

    // `gallery.setActiveMedia` is defined by Dawn's media-gallery.js, which is a
    // separate deferred script loaded later in the page. Deferred scripts run in
    // document order, but there's no guarantee that script has registered the
    // <media-gallery> custom element by the time this handler fires (e.g. slow
    // network, or the element re-rendering after a variant swap). If we call
    // gallery.setActiveMedia() before it exists, the click silently throws and
    // the slide never advances — only the first image ever shows. Guard against
    // that by toggling the active class ourselves immediately (so the click
    // always has a visible effect), then handing off to the full stock behaviour
    // (thumbnail sync, scroll-into-view, video autoplay) once it's ready.
    const setActive = (mediaId, target) => {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        return;
      }

      items.forEach((item) => item.classList.remove('is-active'));
      target?.classList.add('is-active');

      customElements.whenDefined('media-gallery').then(() => {
        gallery.setActiveMedia?.(mediaId, false);
      });
    };

    const move = (direction) => {
      if (!desktopQuery.matches) return;

      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      const target = items[activeIndex + direction];
      if (!target) return;

      setActive(target.dataset.mediaId, target);
      update();
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    gallery.querySelectorAll('[data-target] button').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => window.setTimeout(update));
      thumbnail.addEventListener('pointerenter', () => {
        if (!desktopHoverQuery.matches) return;

        const targetId = thumbnail.closest('[data-target]')?.dataset.target;
        if (!targetId) return;

        const targetItem = items.find((item) => item.dataset.mediaId === targetId);
        setActive(targetId, targetItem);
        update();
      });
    });

    const observer = new MutationObserver(update);
    items.forEach((item) => observer.observe(item, { attributes: true, attributeFilter: ['class'] }));
    update();
  }

  function initAllGalleries(root = document) {
    root.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllGalleries());
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => initAllGalleries(event.target));
})();
